<template>
  <Modal v-model="visible" title="手动登记出勤" width="520" :mask-closable="false" transfer>
    <Form :label-width="90" :show-message="false" label-position="right">
      <Form-item label="老师 ID" required>
        <Input v-model="form.tchId" placeholder="在职外教 ID" style="width: 240px;"></Input>
      </Form-item>
      <Form-item label="日期" required>
        <Date-picker type="date" :value="form.date" :clearable="false" transfer
                     style="width: 240px;" @on-change="form.date = $event"></Date-picker>
      </Form-item>
      <Form-item label="类型" required>
        <Select v-model="form.type" transfer style="width: 240px;">
          <Option v-for="item in typeOptions" :key="item.value" :value="item.value">{{ item.text }}</Option>
        </Select>
      </Form-item>
      <Form-item label="备注">
        <Input v-model="form.note" type="textarea" :rows="3" :maxlength="1000"
               placeholder="可空，最长 1000 字"></Input>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" :loading="saving" @click="submit">登记</Button>
    </div>
  </Modal>
</template>
<script>
import { API_PREFIX, FOLLOWUP_TYPE } from '../constants'
const TYPE_ORDER = ['LEAVE', 'ABSENT', 'LOST', 'LATE']
export default {
  name: 'FollowupManualModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    defaultDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: false,
      saving: false,
      typeOptions: TYPE_ORDER.map(function (code) {
        return { value: code, text: (FOLLOWUP_TYPE[code] && FOLLOWUP_TYPE[code].text) || code }
      }),
      form: {
        tchId: '',
        date: '',
        type: 'LEAVE',
        note: ''
      }
    }
  },
  watch: {
    value (val) {
      this.visible = val
      if (val) {
        this.form = {
          tchId: '',
          date: this.defaultDate || '',
          type: 'LEAVE',
          note: ''
        }
      }
    },
    visible (val) {
      if (val === false) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    submit () {
      let self = this
      let tchId = parseInt(String(self.form.tchId == null ? '' : self.form.tchId).trim(), 10)
      if (!tchId || tchId <= 0) {
        self.$Message.warning('请填写老师 ID')
        return
      }
      if (!self.form.date) {
        self.$Message.warning('请选择日期')
        return
      }
      if (TYPE_ORDER.indexOf(self.form.type) < 0) {
        self.$Message.warning('请选择类型')
        return
      }
      if (self.form.note && self.form.note.length > 1000) {
        self.$Message.warning('备注最长 1000 字')
        return
      }
      self.saving = true
      self.$http.post(API_PREFIX + '/followup/manual', {
        tchId: tchId,
        date: self.form.date,
        type: self.form.type,
        note: self.form.note || ''
      }).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success('已登记')
          self.visible = false
          self.$root.$emit('hr-badges-refresh')
          self.$emit('on-success')
        }
      }).finally(function () {
        self.saving = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// FollowupManualModal.vue?0f29b344